import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.saaspass-vpn', {
        url: '/saaspassVpn',
        component: 'saaspassVpn',
        redirectTo: 'company.saaspass-vpn.integration',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/saaspass-vpn/saaspass-vpn.state.js